import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ChangePasswordService } from "../Service/ChangePassword.Service";
import { ChangePasswordModel } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { ModalComponent } from "../../shared/modeldialog/index";

declare var require: any;
@Component({
    selector: 'MentisSoft-ChangePassword',
    template: require('../Template/ChangePassword.template.html'),
    styles: [require('../Template/ChangePassword.css')]
})

export class ChangePasswordComponent {
    constructor(private _SecurityService: SecurityService, private router: Router, private route: ActivatedRoute, private _ChangePasswordService: ChangePasswordService, private _titleService: Title
    ) {
        this.ChangePasswordInfo.username = localStorage.getItem("patientName");
    }
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    loading = false;
    ChangePasswordInfo: ChangePasswordModel = new ChangePasswordModel();
    errMsg: string = "";
    popMsg: string = "";
    ngAfterViewInit() {
        $('#overlay').hide();
    }
    ForgotSubmit(event) {
        this._titleService.setTitle("Change Password");
        this.loading = true;
        if (this.ChangePasswordInfo !== null && this.ChangePasswordInfo.username !== null && this.ChangePasswordInfo.username !== undefined && this.ChangePasswordInfo.username !== "" && this.ChangePasswordInfo.oldpassword !== null && this.ChangePasswordInfo.oldpassword !== undefined && this.ChangePasswordInfo.Newpassword !== undefined && this.ChangePasswordInfo.Newpassword !== null && this.ChangePasswordInfo.ConfirmPassword !== undefined && this.ChangePasswordInfo.ConfirmPassword !== null && this.ChangePasswordInfo.oldpassword !== "" && this.ChangePasswordInfo.Newpassword !== "" && this.ChangePasswordInfo.ConfirmPassword !== "") {
            if (this.ChangePasswordInfo.Newpassword == this.ChangePasswordInfo.ConfirmPassword) {
                this._ChangePasswordService.validCredentials(this.ChangePasswordInfo)
                    .subscribe(
                    p => {
                        this.loading = false;
                        if (p.IsValid && p.SessionTimeout != "Session Expired") {
                            this.errMsg = "";
                            this.popMsg = "You have Successfully Changed the password , Please Login with your new password ";
                            this.viewModelPopup.open();
                            this._SecurityService.errorMessage = "";
                        }

                        else {
                            this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                            this.router.navigate(["/Login"]);
                        }

                    }
                    ,
                    err => {
                        this.loading = false;
                        this.errMsg = "Invalid Username or Password!";
                        console.log("Error data...");
                    }

                    );
            }
            else {
                this.errMsg = "New password and Confirm Password should be matched";
            }
        }
        else {
            if ((this.ChangePasswordInfo.username == null || this.ChangePasswordInfo.username == undefined || this.ChangePasswordInfo.username == "") && (this.ChangePasswordInfo.oldpassword == null || this.ChangePasswordInfo.oldpassword == undefined || this.ChangePasswordInfo.oldpassword == "") && (this.ChangePasswordInfo.Newpassword == null || this.ChangePasswordInfo.Newpassword == "" || this.ChangePasswordInfo.Newpassword == undefined) && (this.ChangePasswordInfo.ConfirmPassword == null || this.ChangePasswordInfo.ConfirmPassword == "" || this.ChangePasswordInfo.ConfirmPassword == undefined)) {
                this.errMsg = "Your username and password is required.";
            }
            else if ((this.ChangePasswordInfo.oldpassword == null || this.ChangePasswordInfo.oldpassword == undefined || this.ChangePasswordInfo.oldpassword == "") && (this.ChangePasswordInfo.Newpassword == null || this.ChangePasswordInfo.Newpassword == "" || this.ChangePasswordInfo.Newpassword == undefined) && (this.ChangePasswordInfo.ConfirmPassword == null || this.ChangePasswordInfo.ConfirmPassword == "" || this.ChangePasswordInfo.ConfirmPassword == undefined)) {
                this.errMsg = "Your password is required.";
            }
            else if ((this.ChangePasswordInfo.Newpassword == null || this.ChangePasswordInfo.Newpassword == "" || this.ChangePasswordInfo.Newpassword == undefined) && (this.ChangePasswordInfo.ConfirmPassword == null || this.ChangePasswordInfo.ConfirmPassword == "" || this.ChangePasswordInfo.ConfirmPassword == undefined)) {
                this.errMsg = "Your Confirm and New password is required.";
            }
            else if (this.ChangePasswordInfo.oldpassword == null || this.ChangePasswordInfo.oldpassword == undefined || this.ChangePasswordInfo.oldpassword == "") {
                this.errMsg = "Your old password is required.";
            }
            else if (this.ChangePasswordInfo.Newpassword == null || this.ChangePasswordInfo.Newpassword == "" || this.ChangePasswordInfo.Newpassword == undefined) {
                this.errMsg = "Your New password is required.";
            }
            else if (this.ChangePasswordInfo.ConfirmPassword == null || this.ChangePasswordInfo.ConfirmPassword == "" || this.ChangePasswordInfo.ConfirmPassword == undefined) {
                this.errMsg = "Your Confirm password is required.";
            }
            else if (this.ChangePasswordInfo.username == null || this.ChangePasswordInfo.username == undefined || this.ChangePasswordInfo.username == "") {
                this.errMsg = "Your username is required.";
            }
            else if (this.ChangePasswordInfo.Newpassword == this.ChangePasswordInfo.ConfirmPassword) {
                this.errMsg = "Your Confirm and New password should be same";
            }
            else {
                this.errMsg = "Your password is required.";
            }

        }
    }
    closepopup() {
        this.viewModelPopup.close();
        this.router.navigate(["/Dashboard"]);
    }
    logBacktoLogin(event) {
        this.router.navigate(["/Login"]);
    }
    ForgotCancel(event) {
        this.router.navigate(["/PatientProfile"]);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/ChangePassword/Component/ChangePassword.Component.ts